import TEInput from './TEInput';

export default TEInput;
